import { Category, CategoryId } from '@wix/add-panel-common';

export const isVerticalInstalledCategory = (category: Category) =>
  [
    CategoryId.Blog,
    CategoryId.NewBlog,
    CategoryId.Bookings,
    CategoryId.Store,
    CategoryId.Events,
    CategoryId.Members,
    CategoryId.Database,
  ].includes(category.id as CategoryId);

export const isVerticalNotInstalledCategory = (category: Category) =>
  [
    CategoryId.NewBlogWelcome,
    CategoryId.BookingsWelcome,
    CategoryId.StoreWelcome,
    CategoryId.EventsWelcome,
    CategoryId.MembersWelcome,
    CategoryId.DatabaseWelcome,
  ].includes(category.id as CategoryId);

export const isVerticalCategory = (category: Category) =>
  isVerticalInstalledCategory(category) || isVerticalNotInstalledCategory(category);
